import { Injectable } from '@angular/core';
import {
    ActivatedRoute,
    Event,
    NavigationEnd,
    Router
} from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
    BehaviorSubject,
    distinctUntilChanged,
    filter,
    map
} from 'rxjs';

@UntilDestroy()
@Injectable({
    providedIn: 'root'
})
export class SiteChromeService {
    visible$: BehaviorSubject<boolean>;
    // Despite a vast majority of use cases needing the app-shell to be visible, this service needs
    // to set default visibility to `false` in order to prevent a flicker of app-shell in AngularJS
    // routing use cases where app-shell is visibility is hidden by `hideSiteChrome: true`.
    defaultVisibility = false;

    constructor(
        private router: Router
    ) {
        this.visible$ = new BehaviorSubject<boolean>(this.defaultVisibility);
    }

    init() {
        this.router.events
            .pipe(
                filter((event: Event) => event instanceof NavigationEnd),
                distinctUntilChanged(),
                map(() => {
                    let count = 0;
                    let route: ActivatedRoute = this.router.routerState.root;
                    let routeData = {};
                    while (route?.firstChild) {
                        if (count > 300) break;
                        route = route.firstChild;
                        count += 1;
                    }
                    if (route.snapshot.data) {
                        routeData = route?.snapshot.data;
                    }
                    return routeData;
                }),
                untilDestroyed(this)
            )
            .subscribe((routeData: any) => {
                if (!routeData.isAngularJsRoute) {
                    // In practice, default visibility is "true" for Angular routes.
                    // Corresponding behavior for AngularJS is in state-change-events.js
                    this.setVisibility(routeData.hideSiteChrome !== true);
                }
            });
    }

    setVisibility(value: boolean): void {
        this.visible$.next(value);
    }
}
